import React from 'react'
import GameCard from './game_card';
import moment from 'moment';
import _ from 'lodash';

const GameList = (props) => {
    if (!props.games) {
        return <div><h1>No games played on this date</h1></div>
    } else {
        let orderBy = props.order;
        const gameItems = props.games.map(game => {
            let recapButtonDisabled = true;
            let extendedButtonDisabled = true;
            let recapUrl;
            let extendedUrl;
            let startDate = moment(game.gameDate).format('HH:mm');
            let recapVid;
            let extendedVid;
            if (game.content.media.epg[3].items[0] !== undefined) {
                recapVid = game.content.media.epg[3].items[0].playbacks.find(({ name }) => name === "HTTP_CLOUD_WIRED_60");
                if (recapVid !== undefined) {
                    recapUrl = recapVid.url;
                    recapButtonDisabled = false;
                }
            }
            if (game.content.media.epg[2].items[0] !== undefined) {
                extendedVid = game.content.media.epg[2].items[0].playbacks.find(({ name }) => name === "HTTP_CLOUD_WIRED_60");
                if (extendedVid !== undefined) {
                    extendedUrl = extendedVid.url;
                    extendedButtonDisabled = false;
                }

            }
            return (
                <GameCard
                    key={game.gamePk}
                    recapButtonDisabled={recapButtonDisabled}
                    extendedButtonDisabled={extendedButtonDisabled}
                    recapUrl={recapUrl}
                    extendedUrl={extendedUrl}
                    homeTeam={game.teams.home.team}
                    homeScore={game.teams.home.score}
                    awayTeam={game.teams.away.team}
                    awayScore={game.teams.away.score}
                    gameState={game.status.detailedState}
                    gameStart={startDate}
                />
            )
        });

        return (
            <div>
                {_.orderBy(gameItems, ['key'], [orderBy])}
            </div>
        )
    }
}

export default GameList



// WEBPACK FOOTER //
// ./src/components/game_list.jsx